import { render, staticRenderFns } from "./robCustomer.vue?vue&type=template&id=1710ef66&"
import script from "./robCustomer.vue?vue&type=script&lang=js&"
export * from "./robCustomer.vue?vue&type=script&lang=js&"
import style0 from "./robCustomer.vue?vue&type=style&index=0&lang=less&"
import style1 from "./robCustomer.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports